export const DEFAULT_LIFETIME = 0
export const PERMANENT_LIFETIME = 999
export const DEFAULT_LIFETIME_FACTOR = 1
export const DEFAULT_CONVERSION_FACTOR = 1
export const DEFAULT_ACTIVITY_VALUE = 0
export const DEFAULT_ACTIVITY_MODE = 'OVERRIDE'
